import { ReactNode } from 'react';

interface TabPanelProps {
	children?: ReactNode;
	dir?: string;
	index: number;
	value: number;
}

export const TabContent = (props: TabPanelProps) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			{...other}
		>
			{value === index && children}
		</div>
	);
};
